import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import IBAN from 'iban';

export const bbanValidator: ValidatorFn = (c: AbstractControl): ValidationErrors | null => {
  const bban = c.value;

  if (!bban) {
    return null;
  }

  if (bban.length !== 26) {
    return { invalidLength: bban.length };
  }

  if (!IBAN.isValid('PL' + bban)) {
    return { invalidBban: bban };
  }

  return null;
};
